"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _FlamingoSwapInvocationBuilderNeo3_swapTokenToReceiveInvocation, _FlamingoSwapInvocationBuilderNeo3_swapTokenToUseInvocation, _FlamingoSwapInvocationBuilderNeo3_swapUnwrappingNeoInvocation, _FlamingoSwapInvocationBuilderNeo3_unwrapNeoInvocation, _FlamingoSwapInvocationBuilderNeo3_swapReceiveInvocation, _FlamingoSwapInvocationBuilderNeo3_swapWrappingNeoInvocation, _FlamingoSwapInvocationBuilderNeo3_wrapNeoInvocation, _FlamingoSwapInvocationBuilderNeo3_swapToUseInvocation, _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoSwapInvocationBuilderNeo3 = void 0;
const neon_core_1 = require("@cityofzion/neon-core");
const FlamingoSwapConstants_1 = require("../../constants/FlamingoSwapConstants");
const FlamingoSwapHelper_1 = require("../../helpers/FlamingoSwapHelper");
const NeonDappKitInvocationBuilderNeo3_1 = require("./NeonDappKitInvocationBuilderNeo3");
class FlamingoSwapInvocationBuilderNeo3 {
    static swapInvocation(data) {
        const { routePath, network, type } = data;
        const [tokenToUse] = routePath;
        const tokenToReceive = routePath[routePath.length - 1];
        const scriptHashes = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapScriptHashes(network);
        const swapParams = {
            scriptHashes,
            tokenToUse,
            tokenToReceive,
        };
        if (type === 'swapTokenToReceive') {
            return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapTokenToReceiveInvocation).call(this, Object.assign(Object.assign({}, data), swapParams));
        }
        return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapTokenToUseInvocation).call(this, Object.assign(Object.assign({}, data), swapParams));
    }
}
exports.FlamingoSwapInvocationBuilderNeo3 = FlamingoSwapInvocationBuilderNeo3;
_a = FlamingoSwapInvocationBuilderNeo3, _FlamingoSwapInvocationBuilderNeo3_swapTokenToReceiveInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapTokenToReceiveInvocation(data) {
    const { network, routePath } = data;
    if (FlamingoSwapHelper_1.FlamingoSwapHelper.isSwapUnwrappingNeo(network, routePath)) {
        return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapUnwrappingNeoInvocation).call(this, data);
    }
    if (FlamingoSwapHelper_1.FlamingoSwapHelper.isUnwrapNeo(network, routePath)) {
        return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_unwrapNeoInvocation).call(this, data);
    }
    return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapReceiveInvocation).call(this, data);
}, _FlamingoSwapInvocationBuilderNeo3_swapTokenToUseInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapTokenToUseInvocation(data) {
    const { network, routePath } = data;
    if (FlamingoSwapHelper_1.FlamingoSwapHelper.isSwapWrappingNeo(network, routePath)) {
        return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapWrappingNeoInvocation).call(this, data);
    }
    if (FlamingoSwapHelper_1.FlamingoSwapHelper.isWrapNeo(network, routePath)) {
        return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_wrapNeoInvocation).call(this, data);
    }
    return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_swapToUseInvocation).call(this, data);
}, _FlamingoSwapInvocationBuilderNeo3_swapUnwrappingNeoInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapUnwrappingNeoInvocation(data) {
    const { address, amountToReceive, deadline, maximumSelling, network, routePath, scriptHashes, tokenToReceive, tokenToUse, } = data;
    const tokenToReceiveOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToReceive);
    const routePathOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideRoutePath(network, routePath);
    const amountToReceiveFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(amountToReceive, tokenToReceiveOverrode.decimals);
    const maximumSellingFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(maximumSelling, tokenToUse.decimals);
    const amountToReceiveTransfer = neon_core_1.u.BigInteger.fromNumber(Number(amountToReceiveFormatted) * FlamingoSwapConstants_1.FlamingoSwapConstants.UNWRAPPING_FEE).toString();
    const GAS = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'GAS');
    const bNEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'bNEO');
    const unwrapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.transferContractInvocation({
        contractHash: GAS.hash,
        tokenHash: bNEO.hash,
        senderAddress: address,
        amount: amountToReceiveTransfer,
    });
    const unwrapAllowedContracts = [GAS.hash, bNEO.hash];
    const swapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.swapTokenOutForTokenInContractInvocation({
        routerScriptHash: scriptHashes.flamingoSwapRouter,
        senderAddress: address,
        amountToReceive: amountToReceiveFormatted,
        maximumSelling: maximumSellingFormatted,
        deadline,
        args: __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs).call(this, routePathOverrode),
    });
    const swapAllowedContracts = [
        scriptHashes.flamingoSwapRouter,
        scriptHashes.flamingoFactory,
        scriptHashes.flamingoPairWhiteList,
    ];
    const allowedContracts = [
        ...new Set([...swapAllowedContracts, ...unwrapAllowedContracts, ...routePath.map(token => token.hash)]),
    ];
    return {
        invocations: [swapInvocation, unwrapInvocation],
        signers: [
            {
                scopes: neon_core_1.tx.WitnessScope.CustomContracts,
                allowedContracts,
            },
        ],
    };
}, _FlamingoSwapInvocationBuilderNeo3_unwrapNeoInvocation = function _FlamingoSwapInvocationBuilderNeo3_unwrapNeoInvocation(data) {
    const { address, amountToReceive, network, tokenToReceive } = data;
    const tokenToReceiveOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToReceive);
    const amountToReceiveFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(amountToReceive, tokenToReceiveOverrode.decimals);
    const GAS = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'GAS');
    const bNEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'bNEO');
    const unwrappedAmount = FlamingoSwapHelper_1.FlamingoSwapHelper.getUnwrappedAmount(amountToReceiveFormatted);
    const unwrapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.transferContractInvocation({
        contractHash: GAS.hash,
        tokenHash: bNEO.hash,
        senderAddress: address,
        amount: unwrappedAmount,
    });
    const unwrapAllowedContracts = [GAS.hash, bNEO.hash];
    return {
        invocations: [unwrapInvocation],
        signers: [{ scopes: neon_core_1.tx.WitnessScope.CustomContracts, allowedContracts: unwrapAllowedContracts }],
    };
}, _FlamingoSwapInvocationBuilderNeo3_swapReceiveInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapReceiveInvocation(data) {
    const { address, amountToReceive, deadline, maximumSelling, network, routePath, scriptHashes, tokenToReceive, tokenToUse, } = data;
    const tokenToReceiveOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToReceive);
    const routePathOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideRoutePath(network, routePath);
    const amountToReceiveFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(amountToReceive, tokenToReceiveOverrode.decimals);
    const maximumSellingFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(maximumSelling, tokenToUse.decimals);
    const swapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.swapTokenOutForTokenInContractInvocation({
        routerScriptHash: scriptHashes.flamingoSwapRouter,
        senderAddress: address,
        amountToReceive: amountToReceiveFormatted,
        maximumSelling: maximumSellingFormatted,
        deadline,
        args: __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs).call(this, routePathOverrode),
    });
    const swapAllowedContracts = [
        scriptHashes.flamingoSwapRouter,
        scriptHashes.flamingoFactory,
        scriptHashes.flamingoPairWhiteList,
    ];
    const allowedContracts = [...new Set([...swapAllowedContracts, ...routePath.map(token => token.hash)])];
    return {
        invocations: [swapInvocation],
        signers: [{ scopes: neon_core_1.tx.WitnessScope.CustomContracts, allowedContracts }],
    };
}, _FlamingoSwapInvocationBuilderNeo3_swapWrappingNeoInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapWrappingNeoInvocation(data) {
    const { address, amountToUse, network, deadline, minimumReceived, routePath, scriptHashes, tokenToReceive, tokenToUse, } = data;
    const tokenToUseOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToUse);
    const routePathOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideRoutePath(network, routePath);
    const amountToUseFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(amountToUse, tokenToUseOverrode.decimals);
    const minimumReceivedFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(minimumReceived, tokenToReceive.decimals);
    const NEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'NEO');
    const bNEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'bNEO');
    const wrapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.transferContractInvocation({
        contractHash: NEO.hash,
        tokenHash: bNEO.hash,
        senderAddress: address,
        amount: amountToUse,
    });
    const wrapAllowedContracts = [NEO.hash, bNEO.hash];
    const swapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.swapTokenInForTokenOutContractInvocation({
        routerScriptHash: scriptHashes.flamingoSwapRouter,
        amountToUse: amountToUseFormatted,
        minimumReceived: minimumReceivedFormatted,
        senderAddress: address,
        deadline,
        args: __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs).call(this, routePathOverrode),
    });
    const swapAllowedContracts = [
        scriptHashes.flamingoSwapRouter,
        scriptHashes.flamingoFactory,
        scriptHashes.flamingoPairWhiteList,
    ];
    const allowedContracts = [
        ...new Set([...swapAllowedContracts, ...wrapAllowedContracts, ...routePath.map(token => token.hash)]),
    ];
    return {
        invocations: [wrapInvocation, swapInvocation],
        signers: [
            {
                scopes: neon_core_1.tx.WitnessScope.CustomContracts,
                allowedContracts,
            },
        ],
    };
}, _FlamingoSwapInvocationBuilderNeo3_wrapNeoInvocation = function _FlamingoSwapInvocationBuilderNeo3_wrapNeoInvocation(data) {
    const { address, amountToUse, network } = data;
    const NEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'NEO');
    const bNEO = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, 'bNEO');
    const wrapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.transferContractInvocation({
        contractHash: NEO.hash,
        tokenHash: bNEO.hash,
        senderAddress: address,
        amount: amountToUse,
    });
    const wrapAllowedContracts = [NEO.hash, bNEO.hash];
    return {
        invocations: [wrapInvocation],
        signers: [{ scopes: neon_core_1.tx.WitnessScope.CustomContracts, allowedContracts: wrapAllowedContracts }],
    };
}, _FlamingoSwapInvocationBuilderNeo3_swapToUseInvocation = function _FlamingoSwapInvocationBuilderNeo3_swapToUseInvocation(data) {
    const { address, amountToUse, deadline, minimumReceived, network, routePath, scriptHashes, tokenToReceive, tokenToUse, } = data;
    const tokenToUseOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToUse);
    const routePathOverrode = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideRoutePath(network, routePath);
    const amountToUseFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(amountToUse, tokenToUseOverrode.decimals);
    const minimumReceivedFormatted = FlamingoSwapHelper_1.FlamingoSwapHelper.formatAmount(minimumReceived, tokenToReceive.decimals);
    const swapInvocation = NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.swapTokenInForTokenOutContractInvocation({
        routerScriptHash: scriptHashes.flamingoSwapRouter,
        amountToUse: amountToUseFormatted,
        minimumReceived: minimumReceivedFormatted,
        senderAddress: address,
        deadline,
        args: __classPrivateFieldGet(this, _a, "m", _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs).call(this, routePathOverrode),
    });
    const swapAllowedContracts = [
        scriptHashes.flamingoSwapRouter,
        scriptHashes.flamingoFactory,
        scriptHashes.flamingoPairWhiteList,
    ];
    const allowedContracts = [...new Set([...swapAllowedContracts, ...routePath.map(token => token.hash)])];
    return {
        invocations: [swapInvocation],
        signers: [{ scopes: neon_core_1.tx.WitnessScope.CustomContracts, allowedContracts }],
    };
}, _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs = function _FlamingoSwapInvocationBuilderNeo3_mapRoutePathToArgs(routePath) {
    return routePath.map(token => ({
        type: 'Hash160',
        value: token.hash,
    }));
};
